import { styled } from '@vw-marketing/us-components';

export const StyledColorFilterWrapper = styled.div``;

export const StyledCheckboxContainer: any = styled.div<any>`
  width: 76px;
  text-align: center;

  ${(props) => {
    if (props.isDisabled) {
      return { cursor: 'not-allowed', color: '#6a767d' };
    }
    return { cursor: 'pointer' };
  }}
`;

export const StyledColorImage: any = styled.div<any>`
${({background}) => `
  width: 64px;
  height: 64px;
  border: 0.5px solid #6a767d;
  border-radius: 50%;
  margin: auto;
  margin-top: 3px;
  background: ${background};


`}`;

export const StyledCheckmark = styled.div<any>`
  color: #001e50;
  width: 22px;
  height: 22px;
  float: right;
  background-color: #fff;
  border-radius: 50%;
  padding: 1px;

  ${(props) => (props.checked ? { display: 'block' } : { display: 'none' })};
`;

export const StyledColorBorder = styled.div<any>`
  width: 74px;
  height: 74px;
  border-radius: 50%;

  ${(props) =>
    props.checked
      ? { border: 'solid 1.8px #001e50' }
      : { border: 'solid 1.8px #fff' }};
`;

export const StyledDisabled = styled.div`
  margin-top: 3px;
`;

export const StyledLabelContainer = styled.div`
  width: 58px;
  margin: 0 auto;
`;
